import "./App.css";
import Home from "./common/Home";
import Navbar from "./common/Navbar";
import AgricultureLanding from "./common/SinglePage";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const allowedLanguages = [
  "as",
  "bn",
  "brx",
  "doi",
  "en",
  "gu",
  "hi",
  "kn",
  "ks",
  "kok",
  "mai",
  "ml",
  "mni",
  "mr",
  "ne",
  "or",
  "pa",
  "sa",
  "sat",
  "sd",
  "ta",
  "te",
  "ur",
];

function App() {
  useEffect(() => {
    const filterLanguages = () => {
      const selectBox = document.querySelector(".goog-te-combo");
      if (!selectBox) return;

      const selectedLang = localStorage.getItem("selectedLang");

      // Remove disallowed languages
      [...selectBox.options].forEach((option) => {
        if (!allowedLanguages.includes(option.value) && option.value !== "") {
          option.remove();
        }
      });

      // Add custom placeholder if not exists
      if (!selectBox.querySelector("option[value='']")) {
        const placeholder = document.createElement("option");
        placeholder.text = "Select a Language";
        placeholder.value = "";
        placeholder.disabled = true;
        // Placeholder should be selected only if no lang stored or lang is empty string
        placeholder.selected = !selectedLang || selectedLang === "";
        selectBox.insertBefore(placeholder, selectBox.firstChild);
      }

      // Restore previously selected language or default to empty string
      selectBox.value = selectedLang || "";

      // Add listener for changes
      selectBox.addEventListener("change", (e) => {
        const val = e.target.value;
        localStorage.setItem("selectedLang", val);

        // If user selects "Show Original" (empty string), reset Google Translate accordingly
        if (val === "") {
          // Reload page language without translation
          // Google Translate sets "Show Original" by setting cookie `googtrans=/source/target`
          // We manually set cookie to source/source to force original
          document.cookie =
            "googtrans=/en/en; path=/; domain=" +
            window.location.hostname.replace("www.", "");
          window.location.reload();
        }
      });
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", autoDisplay: false },
        "google_translate_element"
      );

      const tryFilter = () => {
        const selectBox = document.querySelector(".goog-te-combo");
        if (selectBox) {
          filterLanguages();

          const observer = new MutationObserver(filterLanguages);
          observer.observe(selectBox, { childList: true, subtree: true });
        } else {
          setTimeout(tryFilter, 250); // keep checking until available
        }
      };

      tryFilter();
    };

    if (!document.querySelector("script[src*='translate_a/element.js']")) {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      {/* <div
        id="google_translate_element"
        style={{ float: "right", margin: "10px" }}
      ></div> */}
      <Navbar />
      <Home />
      {/* <AgricultureLanding /> */}
    </>
  );
}

export default App;
